import * as actions from '../actions';

const defaultMenus = [
  {
    role: 'our_story',
    label: 'about',
  },
  {
    role: 'products',
    label: 'products',
  },
  {
    role: 'press_comments',
    label: 'reviews',
  },
  {
    role: 'policies',
    label: 'need to know',
  },
];

export function menuItems({ customersSection = {} }) {
  const { pressComments = { comments: [] }, topReviews = { reviews: [] } } = customersSection;
  return defaultMenus.filter((menu) => {
    const hide = menu.role === 'press_comments'
      ? pressComments.comments.length === 0 && topReviews.reviews.length === 0
      : false;
    return !hide;
  });
}

function createSession(data, partnerId) {
  return {
    partnerName: (data && data.richSnippet) ? data.richSnippet.name : '',
    partnerId
  };
}

export function storefront(state = {}, action) {
  switch (action.type) {
    case `${actions.FETCH_STOREFRONT_DATA}_PENDING`:
      return {
        ...state,
        loading: true
      };
    case `${actions.FETCH_STOREFRONT_DATA}_FULFILLED`:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        session: createSession(action.payload.data, action.partnerId),
        data: {
          ...action.payload.data,
          menus: menuItems(action.payload.data)
        },
        status: action.status
      };
    case `${actions.FETCH_STOREFRONT_DATA}_REJECTED`:
      return {
        ...state,
        loading: false,
        errors: [action.payload],
        status: action.status
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/storefront/reducers/storefront.js